import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-policy-list',
  templateUrl: './policy-list.component.html',
  styleUrls: ['./policy-list.component.css']
})
export class PolicyListComponent implements OnInit {

  constructor(private router: Router) { }

  ngOnInit() {
  }

  DownloadPolicy(vat) {
    // if (vat == 0) {
      this.router.navigate(["home/HRPoliciyView"],{ queryParams: {PolicyID: vat}});
    // } else if (vat == 1) {

    // }
    //alert(vat);
  }

}
